import { Endpoints } from "../../contants/endpoints";
import { api } from "../../lib/api";

export async function postLoginAuth(
  phoneNumber: string
){
  try {
    const res = (await api.post(Endpoints.auth.login, {
      phoneNumber: phoneNumber,
    })) as any;
    const data = res?.data;

    if (data?.success && data?.data) {
      return data?.data;
    }

    return null;
  } catch (error) {
    console.error("API login auth error:", error);
    return null;
  }
}